unit View.Fornecedores.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, UPersonalizacao_Tabela, UConstantes,
  UPersonalizacao_Tabela.Interfaces, System.StrUtils,
  UFrameFinanceiroFornecedor, Vcl.Forms, XData.Web.Client;

type
  TFViewFornecedoresList = class(TForm)
    FornecedoresDataset: TXDataWebDataSet;
    FornecedoresDatasetid: TIntegerField;
    FornecedoresDatasetrazao_social_nome: TStringField;
    FornecedoresDatasetnome_fantasia_apelido: TStringField;
    FornecedoresDatasetcpf_cnpj: TStringField;
    FornecedoresDatasetrg_ie: TStringField;
    FornecedoresDatasetcadastro: TDateTimeField;
    FornecedoresDatasetstatus: TIntegerField;
    FornecedoresDatasetemail: TStringField;
    FornecedoresDatasetcontato: TStringField;
    FornecedoresDatasetendereco: TStringField;
    FornecedoresDatasetnumero: TStringField;
    FornecedoresDatasetbairro: TStringField;
    FornecedoresDatasetcep: TStringField;
    FornecedoresDatasettelefones: TStringField;
    FornecedoresDatasetprodutor_rural: TBooleanField;
    FornecedoresDatasetcodigo_interno: TIntegerField;
    FornecedoresDatasetexcluido: TBooleanField;
    FornecedoresDatasetinclusao: TDateTimeField;
    FornecedoresDatasetalteracao: TDateTimeField;
    FornecedoresDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    btnExportarExcel: TButton;
    cbbFornecedorStatus: TComboBox;
    cbxFornecedoresExcluidos: TCheckBox;
    edtCidadeNome: TEdit;
    btnPesquisarCidade: TButton;
    cbbFornecedorProdutorRural: TComboBox;
    tmrConsulta: TTimer;
    FornecedoresDatasetcomplemento: TStringField;
    FornecedoresDatasetcidadeNome: TStringField;
    FornecedoresDatasetcidadeufSigla: TStringField;
    frmFinanceiro: TfrmFinanceiroFornecedor;
    lbModalTitulo: TLabel;
    FornecedoresDatasetis_pj: TBooleanField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    [async]
    procedure btnPesquisarCidadeClick(Sender: TObject); async;
    procedure cbbFornecedorProdutorRuralChange(Sender: TObject);
    procedure cbbFornecedorStatusChange(Sender: TObject);
    procedure cbxFornecedoresExcluidosClick(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure FornecedoresDatasetcpf_cnpjGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure FornecedoresDatasetemailGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure FornecedoresDatasetenderecoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure FornecedoresDatasetcepGetText(Sender: TField; var Text: string;
      DisplayText: Boolean);
    procedure FornecedoresDatasettelefonesGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure FornecedoresDatasetcidadeNomeGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure btnExportarExcelClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
    FFornecedorSelecionado : string;

    function GetFiltro : string;
    procedure Filtrar;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewFornecedoresList: TFViewFornecedoresList;

implementation

uses
  ConnectionModule, UHelperServer;

{$R *.dfm}

{ TFViewFornecedoresList }

procedure TFViewFornecedoresList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(FornecedoresDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewFornecedoresList.btnPesquisarCidadeClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtCidadeNome.Tag;
  Await(THelperServer.ChamarConsulta('Cidades', 'Cidade', edtCidadeNome));

  if lBackupTag <> edtCidadeNome.Tag then
    Filtrar;
end;

procedure TFViewFornecedoresList.cbbFornecedorProdutorRuralChange(
  Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewFornecedoresList.cbbFornecedorStatusChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewFornecedoresList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewFornecedoresList.cbxFornecedoresExcluidosClick(Sender: TObject);
begin
  Filtrar;
end;

class function TFViewFornecedoresList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFornecedoresList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewFornecedoresList, AElementID, Result, @AfterCreate);
end;

procedure TFViewFornecedoresList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewFornecedoresList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewFornecedoresList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

procedure TFViewFornecedoresList.FornecedoresDatasetcepGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCEP(Sender.AsString);
end;

procedure TFViewFornecedoresList.FornecedoresDatasetcidadeNomeGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCidadeEstado(Sender.AsString, FornecedoresDataset.FieldByName('cidade.uf.Sigla').AsString);
end;

procedure TFViewFornecedoresList.FornecedoresDatasetcpf_cnpjGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewFornecedoresList.FornecedoresDatasetemailGetText(Sender: TField;
  var Text: string; DisplayText: Boolean);
begin
  Text := UpperCase(Sender.AsString);
end;

procedure TFViewFornecedoresList.FornecedoresDatasetenderecoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.FormatarEndereco(Sender.AsString, FornecedoresDataset.FieldByName('numero').AsString,
    FornecedoresDataset.FieldByName('bairro').AsString, EmptyStr);
end;

procedure TFViewFornecedoresList.FornecedoresDatasettelefonesGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTelefoneUnicoJson(Sender.AsString);
end;

function TFViewFornecedoresList.GetFiltro: string;
var
  lFiltroProdutorRural : string;
begin
  case cbbFornecedorStatus.ItemIndex of
    0 : Result := '(status ne 2)';
    3 : Result := EmptyStr
    else Result := '(status eq ' + cbbFornecedorStatus.ItemIndex.ToString + ')';
  end;

  if not cbxFornecedoresExcluidos.Checked then
  begin
    if Trim(Result).IsEmpty then
      Result := '(excluido eq false)'
    else
      Result := Result + ' and (excluido eq false)';
  end;

  if edtCidadeNome.Tag <> 0 then
  begin
    if Trim(Result).IsEmpty then
      Result := '(cidade_id eq '+edtCidadeNome.Tag.ToString+')'
    else
      Result := Result + ' and (cidade_id eq '+edtCidadeNome.Tag.ToString+')';
  end;

  case cbbFornecedorProdutorRural.ItemIndex of
    0 : lFiltroProdutorRural := '(produtor_rural eq true)';
    1 : lFiltroProdutorRural := '(produtor_rural eq false)';
    else lFiltroProdutorRural := EmptyStr;
  end;

  if not lFiltroProdutorRural.IsEmpty then
  begin
    if Trim(Result).IsEmpty then
      Result := lFiltroProdutorRural
    else
      Result := Result + ' and ' + lFiltroProdutorRural;
  end;
end;

procedure TFViewFornecedoresList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewFornecedoresList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordFornecedorId,
  RecordNome : string;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure FinanceiroButtonClick(Sender: TObject);
  begin
    if FFornecedorSelecionado <> RecordFornecedorId then
    begin
      FFornecedorSelecionado := RecordFornecedorId;
      TUtils.SelecionarTab('#line-debitos-tab');
      lbModalTitulo.Caption := RecordNome;
      frmFinanceiro.cdsDebitos.Tag := 0;
      frmFinanceiro.cdsPagamentos.Tag := 0;
      frmFinanceiro.CarregarInformacoesIniciais(RecordFornecedorId);
    end;

    TUtils.OpenModal('modal_financeiro_fornecedor');
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      FornecedoresDataset.Connection.Model.DefaultSchema.FindEntityType(FornecedoresDataset.EntitySetName),
      FornecedoresDataset.CurrentData
    );

    RecordFornecedorId := FornecedoresDataset.FieldByName('id').AsString;

    if FornecedoresDataset.FieldByName('is_pj').AsBoolean then
      RecordNome := FornecedoresDataset.FieldByName('nome_fantasia_apelido').AsString
    else
      RecordNome := FornecedoresDataset.FieldByName('razao_social_nome').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_fornecedor');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-money-check-alt"></i>';
    Button.OnClick := @FinanceiroButtonClick;
    Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver financeiro fornecedor');
    Button.ElementHandle.setAttribute('data-test', 'btn_financeiro_fornecedor');
  end;
end;

procedure TFViewFornecedoresList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['cpf_cnpj', 'telefones',
      'email', 'endereco', 'cidade.Nome', 'razao_social_nome', 'nome_fantasia_apelido',
      'contato', 'rg_ie']) of
      0, 1, 2, 3, 4, 5, 6, 7, 8: AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewFornecedoresList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;

  case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['status', 'excluido', 'produtor_rural']) of
    0:
    begin
      case StrToInt(AValue) of
        1 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
        2 : AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
        else AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">Outros</div>';
      end;
    end;
    1, 2:
    begin
      if AValue = 'True' then
        AValue := '<i class="fas fa-check text-success"><i>'
      else if AValue = 'False' then
        AValue := '<i class="fas fa-times text-danger"><i>';
    end;
  end;
end;

procedure TFViewFornecedoresList.WebFormCreate(Sender: TObject);
var
  lFiltro : string;
begin
  FFornecedorSelecionado := EmptyStr;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('fornecedores', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, FornecedoresDataset, lcPaginator,
    lbPaginationInfo);

  lFiltro := Trim(GetFiltro);
  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'nome_fantasia_apelido, razao_social_nome';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewFornecedoresList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.fornecedores.list.pagination.info');
  lbModalTitulo := TLabel.Create('modal_financeiro_fornecedor_Label');
  WebDBTableControl1 := TDBTableControl.Create('view.fornecedores.list.table');
  cbPageSize := TComboBox.Create('view.fornecedores.list.cbPageSize');
  edSearch := TEdit.Create('view.fornecedores.list.search');
  lcPaginator := TListControl.Create('view.fornecedores.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  cbbFornecedorStatus := TComboBox.Create('cbbFornecedorStatus');
  cbxFornecedoresExcluidos := TCheckBox.Create('cbxFornecedoresExcluidos');
  edtCidadeNome := TEdit.Create('edtCidadeNome');
  btnPesquisarCidade := TButton.Create('btnPesquisarCidade');
  cbbFornecedorProdutorRural := TComboBox.Create('cbbFornecedorProdutorRural');
  frmFinanceiro := TfrmFinanceiroFornecedor.Create(Self);
  FornecedoresDataset := TXDataWebDataSet.Create(Self);
  FornecedoresDatasetcodigo_interno := TIntegerField.Create(Self);
  FornecedoresDatasetrazao_social_nome := TStringField.Create(Self);
  FornecedoresDatasetnome_fantasia_apelido := TStringField.Create(Self);
  FornecedoresDatasetcpf_cnpj := TStringField.Create(Self);
  FornecedoresDatasetrg_ie := TStringField.Create(Self);
  FornecedoresDatasetstatus := TIntegerField.Create(Self);
  FornecedoresDatasetcontato := TStringField.Create(Self);
  FornecedoresDatasettelefones := TStringField.Create(Self);
  FornecedoresDatasetemail := TStringField.Create(Self);
  FornecedoresDatasetcidadeNome := TStringField.Create(Self);
  FornecedoresDatasetcidadeufSigla := TStringField.Create(Self);
  FornecedoresDatasetcep := TStringField.Create(Self);
  FornecedoresDatasetendereco := TStringField.Create(Self);
  FornecedoresDatasetnumero := TStringField.Create(Self);
  FornecedoresDatasetbairro := TStringField.Create(Self);
  FornecedoresDatasetcomplemento := TStringField.Create(Self);
  FornecedoresDatasetcadastro := TDateTimeField.Create(Self);
  FornecedoresDatasetprodutor_rural := TBooleanField.Create(Self);
  FornecedoresDatasetis_pj := TBooleanField.Create(Self);
  FornecedoresDatasetexcluido := TBooleanField.Create(Self);
  FornecedoresDatasetinclusao := TDateTimeField.Create(Self);
  FornecedoresDatasetalteracao := TDateTimeField.Create(Self);
  FornecedoresDatasetexclusao := TDateTimeField.Create(Self);
  FornecedoresDatasetid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  frmFinanceiro.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  lbModalTitulo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  cbbFornecedorStatus.BeforeLoadDFMValues;
  cbxFornecedoresExcluidos.BeforeLoadDFMValues;
  edtCidadeNome.BeforeLoadDFMValues;
  btnPesquisarCidade.BeforeLoadDFMValues;
  cbbFornecedorProdutorRural.BeforeLoadDFMValues;
  frmFinanceiro.BeforeLoadDFMValues;
  frmFinanceiro.lbPaginationInfoDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosAVencer.BeforeLoadDFMValues;
  frmFinanceiro.lblDebitosVencidos.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalDebitos.BeforeLoadDFMValues;
  frmFinanceiro.lblUltimaCompra.BeforeLoadDFMValues;
  frmFinanceiro.lblTotalCompras.BeforeLoadDFMValues;
  frmFinanceiro.lblQuantidadeCompras.BeforeLoadDFMValues;
  frmFinanceiro.XDataClientResumoFinanceiro.BeforeLoadDFMValues;
  FornecedoresDataset.BeforeLoadDFMValues;
  FornecedoresDatasetcodigo_interno.BeforeLoadDFMValues;
  FornecedoresDatasetrazao_social_nome.BeforeLoadDFMValues;
  FornecedoresDatasetnome_fantasia_apelido.BeforeLoadDFMValues;
  FornecedoresDatasetcpf_cnpj.BeforeLoadDFMValues;
  FornecedoresDatasetrg_ie.BeforeLoadDFMValues;
  FornecedoresDatasetstatus.BeforeLoadDFMValues;
  FornecedoresDatasetcontato.BeforeLoadDFMValues;
  FornecedoresDatasettelefones.BeforeLoadDFMValues;
  FornecedoresDatasetemail.BeforeLoadDFMValues;
  FornecedoresDatasetcidadeNome.BeforeLoadDFMValues;
  FornecedoresDatasetcidadeufSigla.BeforeLoadDFMValues;
  FornecedoresDatasetcep.BeforeLoadDFMValues;
  FornecedoresDatasetendereco.BeforeLoadDFMValues;
  FornecedoresDatasetnumero.BeforeLoadDFMValues;
  FornecedoresDatasetbairro.BeforeLoadDFMValues;
  FornecedoresDatasetcomplemento.BeforeLoadDFMValues;
  FornecedoresDatasetcadastro.BeforeLoadDFMValues;
  FornecedoresDatasetprodutor_rural.BeforeLoadDFMValues;
  FornecedoresDatasetis_pj.BeforeLoadDFMValues;
  FornecedoresDatasetexcluido.BeforeLoadDFMValues;
  FornecedoresDatasetinclusao.BeforeLoadDFMValues;
  FornecedoresDatasetalteracao.BeforeLoadDFMValues;
  FornecedoresDatasetexclusao.BeforeLoadDFMValues;
  FornecedoresDatasetid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewFornecedoresList';
    Width := 588;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 175;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    lbModalTitulo.SetParentComponent(Self);
    lbModalTitulo.Name := 'lbModalTitulo';
    lbModalTitulo.Left := 368;
    lbModalTitulo.Top := 152;
    lbModalTitulo.Width := 62;
    lbModalTitulo.Height := 13;
    lbModalTitulo.Caption := 'lbModalTitulo';
    lbModalTitulo.HeightPercent := 100.000000000000000000;
    lbModalTitulo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 321;
    WebDBTableControl1.Height := 123;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 100;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'razao_social_nome';
      Title := 'Nome/Raz'#227'o Social';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome_fantasia_apelido';
      Title := 'Apelido/Nome Fantasia';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cpf_cnpj';
      Title := 'Documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'rg_ie';
      Title := 'RG/IE';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'contato';
      Title := 'contato';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'telefones';
      Title := 'telefone';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cidade.Nome';
      Title := 'Cidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cep';
      Title := 'cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'endereco';
      Title := 'Endere'#231'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produtor_rural';
      Title := 'produtor rural';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 208;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 144;
    lcPaginator.Top := 175;
    lcPaginator.Width := 185;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 368;
    btnExportarExcel.Top := 9;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    cbbFornecedorStatus.SetParentComponent(Self);
    cbbFornecedorStatus.Name := 'cbbFornecedorStatus';
    cbbFornecedorStatus.Left := 368;
    cbbFornecedorStatus.Top := 69;
    cbbFornecedorStatus.Width := 96;
    cbbFornecedorStatus.Height := 21;
    cbbFornecedorStatus.HeightPercent := 100.000000000000000000;
    cbbFornecedorStatus.Text := '<> Inativo';
    cbbFornecedorStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbFornecedorStatus, Self, 'OnChange', 'cbbFornecedorStatusChange');
    cbbFornecedorStatus.ItemIndex := 0;
    cbbFornecedorStatus.Items.BeginUpdate;
    try
      cbbFornecedorStatus.Items.Clear;
      cbbFornecedorStatus.Items.Add('<> Inativo');
      cbbFornecedorStatus.Items.Add('Ativo');
      cbbFornecedorStatus.Items.Add('Inativo');
      cbbFornecedorStatus.Items.Add('Todos');
    finally
      cbbFornecedorStatus.Items.EndUpdate;
    end;
    cbxFornecedoresExcluidos.SetParentComponent(Self);
    cbxFornecedoresExcluidos.Name := 'cbxFornecedoresExcluidos';
    cbxFornecedoresExcluidos.Left := 368;
    cbxFornecedoresExcluidos.Top := 96;
    cbxFornecedoresExcluidos.Width := 145;
    cbxFornecedoresExcluidos.Height := 22;
    cbxFornecedoresExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxFornecedoresExcluidos.ChildOrder := 9;
    cbxFornecedoresExcluidos.HeightPercent := 100.000000000000000000;
    cbxFornecedoresExcluidos.WidthPercent := 100.000000000000000000;
    SetEvent(cbxFornecedoresExcluidos, Self, 'OnClick', 'cbxFornecedoresExcluidosClick');
    edtCidadeNome.SetParentComponent(Self);
    edtCidadeNome.Name := 'edtCidadeNome';
    edtCidadeNome.Left := 368;
    edtCidadeNome.Top := 124;
    edtCidadeNome.Width := 120;
    edtCidadeNome.Height := 22;
    edtCidadeNome.ChildOrder := 21;
    edtCidadeNome.Enabled := False;
    edtCidadeNome.HeightPercent := 100.000000000000000000;
    edtCidadeNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCidade.SetParentComponent(Self);
    btnPesquisarCidade.Name := 'btnPesquisarCidade';
    btnPesquisarCidade.Left := 489;
    btnPesquisarCidade.Top := 124;
    btnPesquisarCidade.Width := 30;
    btnPesquisarCidade.Height := 22;
    btnPesquisarCidade.ChildOrder := 22;
    btnPesquisarCidade.HeightPercent := 100.000000000000000000;
    btnPesquisarCidade.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCidade, Self, 'OnClick', 'btnPesquisarCidadeClick');
    cbbFornecedorProdutorRural.SetParentComponent(Self);
    cbbFornecedorProdutorRural.Name := 'cbbFornecedorProdutorRural';
    cbbFornecedorProdutorRural.Left := 368;
    cbbFornecedorProdutorRural.Top := 42;
    cbbFornecedorProdutorRural.Width := 96;
    cbbFornecedorProdutorRural.Height := 21;
    cbbFornecedorProdutorRural.HeightPercent := 100.000000000000000000;
    cbbFornecedorProdutorRural.Text := 'Todos';
    cbbFornecedorProdutorRural.WidthPercent := 100.000000000000000000;
    SetEvent(cbbFornecedorProdutorRural, Self, 'OnChange', 'cbbFornecedorProdutorRuralChange');
    cbbFornecedorProdutorRural.ItemIndex := 2;
    cbbFornecedorProdutorRural.Items.BeginUpdate;
    try
      cbbFornecedorProdutorRural.Items.Clear;
      cbbFornecedorProdutorRural.Items.Add('Sim');
      cbbFornecedorProdutorRural.Items.Add('N'#227'o');
      cbbFornecedorProdutorRural.Items.Add('Todos');
    finally
      cbbFornecedorProdutorRural.Items.EndUpdate;
    end;
    frmFinanceiro.SetParentComponent(Self);
    frmFinanceiro.Name := 'frmFinanceiro';
    frmFinanceiro.Left := 8;
    frmFinanceiro.Top := 208;
    frmFinanceiro.Width := 564;
    frmFinanceiro.Height := 253;
    frmFinanceiro.TabOrder := 10;
    frmFinanceiro.Visible := False;
    frmFinanceiro.lbPaginationInfoDebitos.Width := 141;
    frmFinanceiro.lbPaginationInfoDebitos.Height := 13;
    frmFinanceiro.lblDebitosAVencer.Width := 4;
    frmFinanceiro.lblDebitosAVencer.Height := 13;
    frmFinanceiro.lblDebitosVencidos.Width := 4;
    frmFinanceiro.lblDebitosVencidos.Height := 13;
    frmFinanceiro.lblTotalDebitos.Width := 4;
    frmFinanceiro.lblTotalDebitos.Height := 13;
    frmFinanceiro.lblUltimaCompra.Width := 4;
    frmFinanceiro.lblUltimaCompra.Height := 13;
    frmFinanceiro.lblTotalCompras.Width := 4;
    frmFinanceiro.lblTotalCompras.Height := 13;
    frmFinanceiro.lblQuantidadeCompras.Width := 4;
    frmFinanceiro.lblQuantidadeCompras.Height := 13;
    SetEvent(frmFinanceiro.XDataClientResumoFinanceiro, Self, 'OnLoad', 'nil');
    SetEvent(frmFinanceiro.XDataClientResumoFinanceiro, Self, 'OnError', 'nil');
    FornecedoresDataset.SetParentComponent(Self);
    FornecedoresDataset.Name := 'FornecedoresDataset';
    FornecedoresDataset.EntitySetName := 'Fornecedores';
    FornecedoresDataset.Connection := DMConnection.ApiConnection;
    FornecedoresDataset.Left := 56;
    FornecedoresDataset.Top := 56;
    FornecedoresDatasetcodigo_interno.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcodigo_interno.Name := 'FornecedoresDatasetcodigo_interno';
    FornecedoresDatasetcodigo_interno.FieldName := 'codigo_interno';
    FornecedoresDatasetcodigo_interno.Required := True;
    FornecedoresDatasetrazao_social_nome.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetrazao_social_nome.Name := 'FornecedoresDatasetrazao_social_nome';
    FornecedoresDatasetrazao_social_nome.FieldName := 'razao_social_nome';
    FornecedoresDatasetrazao_social_nome.Required := True;
    FornecedoresDatasetrazao_social_nome.Size := 255;
    FornecedoresDatasetnome_fantasia_apelido.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetnome_fantasia_apelido.Name := 'FornecedoresDatasetnome_fantasia_apelido';
    FornecedoresDatasetnome_fantasia_apelido.FieldName := 'nome_fantasia_apelido';
    FornecedoresDatasetnome_fantasia_apelido.Size := 255;
    FornecedoresDatasetcpf_cnpj.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcpf_cnpj.Name := 'FornecedoresDatasetcpf_cnpj';
    FornecedoresDatasetcpf_cnpj.FieldName := 'cpf_cnpj';
    SetEvent(FornecedoresDatasetcpf_cnpj, Self, 'OnGetText', 'FornecedoresDatasetcpf_cnpjGetText');
    FornecedoresDatasetcpf_cnpj.Size := 255;
    FornecedoresDatasetrg_ie.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetrg_ie.Name := 'FornecedoresDatasetrg_ie';
    FornecedoresDatasetrg_ie.FieldName := 'rg_ie';
    FornecedoresDatasetrg_ie.Size := 255;
    FornecedoresDatasetstatus.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetstatus.Name := 'FornecedoresDatasetstatus';
    FornecedoresDatasetstatus.FieldName := 'status';
    FornecedoresDatasetstatus.Required := True;
    FornecedoresDatasetcontato.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcontato.Name := 'FornecedoresDatasetcontato';
    FornecedoresDatasetcontato.FieldName := 'contato';
    FornecedoresDatasetcontato.Size := 255;
    FornecedoresDatasettelefones.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasettelefones.Name := 'FornecedoresDatasettelefones';
    FornecedoresDatasettelefones.FieldName := 'telefones';
    FornecedoresDatasettelefones.Required := True;
    SetEvent(FornecedoresDatasettelefones, Self, 'OnGetText', 'FornecedoresDatasettelefonesGetText');
    FornecedoresDatasettelefones.Size := 255;
    FornecedoresDatasetemail.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetemail.Name := 'FornecedoresDatasetemail';
    FornecedoresDatasetemail.FieldName := 'email';
    SetEvent(FornecedoresDatasetemail, Self, 'OnGetText', 'FornecedoresDatasetemailGetText');
    FornecedoresDatasetemail.Size := 255;
    FornecedoresDatasetcidadeNome.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcidadeNome.Name := 'FornecedoresDatasetcidadeNome';
    FornecedoresDatasetcidadeNome.FieldName := 'cidade.Nome';
    SetEvent(FornecedoresDatasetcidadeNome, Self, 'OnGetText', 'FornecedoresDatasetcidadeNomeGetText');
    FornecedoresDatasetcidadeufSigla.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcidadeufSigla.Name := 'FornecedoresDatasetcidadeufSigla';
    FornecedoresDatasetcidadeufSigla.Tag := 3;
    FornecedoresDatasetcidadeufSigla.FieldName := 'cidade.uf.Sigla';
    FornecedoresDatasetcep.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcep.Name := 'FornecedoresDatasetcep';
    FornecedoresDatasetcep.FieldName := 'cep';
    FornecedoresDatasetcep.Required := True;
    SetEvent(FornecedoresDatasetcep, Self, 'OnGetText', 'FornecedoresDatasetcepGetText');
    FornecedoresDatasetcep.Size := 255;
    FornecedoresDatasetendereco.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetendereco.Name := 'FornecedoresDatasetendereco';
    FornecedoresDatasetendereco.FieldName := 'endereco';
    SetEvent(FornecedoresDatasetendereco, Self, 'OnGetText', 'FornecedoresDatasetenderecoGetText');
    FornecedoresDatasetendereco.Size := 255;
    FornecedoresDatasetnumero.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetnumero.Name := 'FornecedoresDatasetnumero';
    FornecedoresDatasetnumero.Tag := 3;
    FornecedoresDatasetnumero.FieldName := 'numero';
    FornecedoresDatasetnumero.Size := 255;
    FornecedoresDatasetbairro.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetbairro.Name := 'FornecedoresDatasetbairro';
    FornecedoresDatasetbairro.Tag := 3;
    FornecedoresDatasetbairro.FieldName := 'bairro';
    FornecedoresDatasetbairro.Size := 255;
    FornecedoresDatasetcomplemento.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcomplemento.Name := 'FornecedoresDatasetcomplemento';
    FornecedoresDatasetcomplemento.Tag := 3;
    FornecedoresDatasetcomplemento.FieldName := 'complemento';
    FornecedoresDatasetcomplemento.Size := 255;
    FornecedoresDatasetcadastro.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetcadastro.Name := 'FornecedoresDatasetcadastro';
    FornecedoresDatasetcadastro.FieldName := 'cadastro';
    FornecedoresDatasetcadastro.DisplayFormat := 'dd/mm/yy';
    FornecedoresDatasetprodutor_rural.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetprodutor_rural.Name := 'FornecedoresDatasetprodutor_rural';
    FornecedoresDatasetprodutor_rural.FieldName := 'produtor_rural';
    FornecedoresDatasetis_pj.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetis_pj.Name := 'FornecedoresDatasetis_pj';
    FornecedoresDatasetis_pj.Tag := 3;
    FornecedoresDatasetis_pj.FieldName := 'is_pj';
    FornecedoresDatasetexcluido.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetexcluido.Name := 'FornecedoresDatasetexcluido';
    FornecedoresDatasetexcluido.FieldName := 'excluido';
    FornecedoresDatasetinclusao.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetinclusao.Name := 'FornecedoresDatasetinclusao';
    FornecedoresDatasetinclusao.FieldName := 'inclusao';
    FornecedoresDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    FornecedoresDatasetalteracao.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetalteracao.Name := 'FornecedoresDatasetalteracao';
    FornecedoresDatasetalteracao.FieldName := 'alteracao';
    FornecedoresDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    FornecedoresDatasetexclusao.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetexclusao.Name := 'FornecedoresDatasetexclusao';
    FornecedoresDatasetexclusao.FieldName := 'exclusao';
    FornecedoresDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    FornecedoresDatasetid.SetParentComponent(FornecedoresDataset);
    FornecedoresDatasetid.Name := 'FornecedoresDatasetid';
    FornecedoresDatasetid.Tag := 1;
    FornecedoresDatasetid.FieldName := 'id';
    FornecedoresDatasetid.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := FornecedoresDataset;
    WebDataSource.Left := 184;
    WebDataSource.Top := 64;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 272;
    tmrConsulta.Top := 56;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    lbModalTitulo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    cbbFornecedorStatus.AfterLoadDFMValues;
    cbxFornecedoresExcluidos.AfterLoadDFMValues;
    edtCidadeNome.AfterLoadDFMValues;
    btnPesquisarCidade.AfterLoadDFMValues;
    cbbFornecedorProdutorRural.AfterLoadDFMValues;
    frmFinanceiro.AfterLoadDFMValues;
    frmFinanceiro.lbPaginationInfoDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosAVencer.AfterLoadDFMValues;
    frmFinanceiro.lblDebitosVencidos.AfterLoadDFMValues;
    frmFinanceiro.lblTotalDebitos.AfterLoadDFMValues;
    frmFinanceiro.lblUltimaCompra.AfterLoadDFMValues;
    frmFinanceiro.lblTotalCompras.AfterLoadDFMValues;
    frmFinanceiro.lblQuantidadeCompras.AfterLoadDFMValues;
    frmFinanceiro.XDataClientResumoFinanceiro.AfterLoadDFMValues;
    FornecedoresDataset.AfterLoadDFMValues;
    FornecedoresDatasetcodigo_interno.AfterLoadDFMValues;
    FornecedoresDatasetrazao_social_nome.AfterLoadDFMValues;
    FornecedoresDatasetnome_fantasia_apelido.AfterLoadDFMValues;
    FornecedoresDatasetcpf_cnpj.AfterLoadDFMValues;
    FornecedoresDatasetrg_ie.AfterLoadDFMValues;
    FornecedoresDatasetstatus.AfterLoadDFMValues;
    FornecedoresDatasetcontato.AfterLoadDFMValues;
    FornecedoresDatasettelefones.AfterLoadDFMValues;
    FornecedoresDatasetemail.AfterLoadDFMValues;
    FornecedoresDatasetcidadeNome.AfterLoadDFMValues;
    FornecedoresDatasetcidadeufSigla.AfterLoadDFMValues;
    FornecedoresDatasetcep.AfterLoadDFMValues;
    FornecedoresDatasetendereco.AfterLoadDFMValues;
    FornecedoresDatasetnumero.AfterLoadDFMValues;
    FornecedoresDatasetbairro.AfterLoadDFMValues;
    FornecedoresDatasetcomplemento.AfterLoadDFMValues;
    FornecedoresDatasetcadastro.AfterLoadDFMValues;
    FornecedoresDatasetprodutor_rural.AfterLoadDFMValues;
    FornecedoresDatasetis_pj.AfterLoadDFMValues;
    FornecedoresDatasetexcluido.AfterLoadDFMValues;
    FornecedoresDatasetinclusao.AfterLoadDFMValues;
    FornecedoresDatasetalteracao.AfterLoadDFMValues;
    FornecedoresDatasetexclusao.AfterLoadDFMValues;
    FornecedoresDatasetid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
